import { controlsSelectorMap } from '../../config/player';

import { PlayerMappedControls } from './../../types';

const displayControls = (controls: PlayerMappedControls[], divElement: HTMLDivElement) => {
  Object.keys(controlsSelectorMap).forEach((control: PlayerMappedControls) => {
    const elem = divElement.querySelector(controlsSelectorMap[control]);

    if (!elem) return;

    controls.includes(control) ? elem.classList.add('hidden') : elem.classList.remove('hidden');
  });
};

export default displayControls;
